import React from 'react';
import Wrp from "../../../hoc/Wrp/Wrp";
import { isSet } from '../../../Utils/CommonFunctions';
import SplitViewSideBarToggle from '../../../Components/SplitViewSideBarToggle';
import Icons from '../../../Components/Icons/Icons';
import Buttons from '../../../Components/UI/Buttons';
import PaginationLeftNav from "../../../Components/UI/TableRecord/PaginationLeftNav";

const LeftNav = (props) => {
	const {toggleVariableModel,variableList} = props;
	return (
		<SplitViewSideBarToggle>
			<div className="filter_Header p-2" >
	          <div className="d-flex border-bottom">
	            <ul className="nav nav-pills navcrm-primary nav-pills-no-bd pl-0">
                  <li className="nav-item pl-2 cursor-pointer">  
                    <a className="nav-link show active">
                      Variable
                    </a>
                  </li>
	            </ul>
	          </div>
	          
	            <div className="d-flex align-items-center justify-content-between">
	              <div className="pr-0 cursor-pointer">
				  <form onSubmit={props.submitSearch}>
	                <div className="nav-item dropdown search-dropdown">
	                  <a data-toggle="dropdown" className="nav-item nav-link dropdown-toggle hidden-caret" href="#">  <i className="fa fa-search secondary_color"></i>
	                  </a>
	                  <a data-toggle="dropdown" className="nav-item nav-link dropdown-toggle d-none hidden-caret" href="#"> <i className="fas fa-times primary_color"></i>
	                  </a>
	                  <div className="dropdown-menu">
	                    <div>
	                      <div className="input-group search-box">
						  <input type="text" value={props.pagination.search}  onChange={(e)=>props.updateSearch(e)}  id="search" className="form-control" placeholder="Search here..." />	                      </div>
	                    </div>
	                  </div>
	                </div>
					</form>
	              </div>
	              <div className="pr-2">
	                <div className="selectgroup ">
	                  <div className="selectgroup-item "> <span className="selectgroup-button selectgroup-button-icon primary_bg" onClick={toggleVariableModel}>
	                      <Icons iconType="AddPlus" />
	                    </span>
	                  </div>
	                </div>
	              </div>
	            </div>
	              
	        </div>

	        { props.response && variableList.length>0? 
	          <Wrp>
	            <div className="filter_Body p-0">
	              <div className="table-responsive">
	                <table className="table table-striped">
	                  <thead>
	                    <tr className="text-small">
	                      <th style={{"minWidth":"51px"}} key={'action'}></th>
	                      <th style={{"minWidth":"120px","fontSize":"0.9rem"}}  key={'name'}>Name</th>
	                      <th style={{"minWidth":"120px","fontSize":"0.9rem"}}  key={'fieldtype'}>
	                        <span className="cursor-pointer">
	                          <span>Field Type </span>
	                        </span>
	                      </th>                      
	                    </tr>
	                  </thead>
	                  
	                  <tbody> 
	                  {
	                    variableList ? 
	                    variableList.map((arr,i) => {
							let deleteAction = {
								svgIcon:'Delete',
								title:'',
								isConfirm:true,
								clickHandler:(e)=>props.deleteVaraibleHandler(arr.id)
							  }
	                        if(arr.function_type ==='API' || isSet(arr.default,false)===true){
	                          deleteAction={};
	                        }
							let buttonList = [
	                            {
	                              svgIcon:'Edit',
	                              title:'',
	                              clickHandler:e=>props.editToggleModel(arr)
	                            },
	                            {...deleteAction}
	                          ];  
                          	return (
	                              <tr key={i}>
	                                <td>
	                                  <Buttons buttonList={buttonList} />
	                                </td>                                
	                                <td>
	                                  <div className="tbodyTitle">{arr.variable_name}</div>
	                                </td>
	                                <td className="position-relative">
	                                  <div className={`tbodyTitle inputValue`}>{arr.fieldtype_name}
	                                    <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic'}}>({arr.function_type})</span>
	                                  </div>
	                                </td>
	                              </tr>
	                            )
	                        })
	                    : null
	                  }
	                  </tbody>
	                  
	                </table>
	              
	              </div>
	            </div>
	            <div className="filter_Footer">
	              <div className="dataTables_length p-2">
	                <label className="pl-0"> <span className="badge badge-warning secondary_color">
	                {
	                    variableList ?
						props.pagination.totalRecords
	                    : 0
	                }
	                </span>
	                </label>
	              </div>
				  {
                props.pagination.perPage ?
                <PaginationLeftNav page={props.pagination.page} search={props.pagination.search} perPage={props.pagination.perPage} totalRecords={props.pagination.totalRecords}
                  recordsChangeHandler={props.recordsChangeHandler}
                   />
				   :
				   ''
				 }

	            </div>
	          </Wrp>
	          :
	          null
	        }
		</SplitViewSideBarToggle>
	)

}

export default LeftNav;